import React, { useLayoutEffect, useRef, useState } from 'react'
import ReactDOM from 'react-dom'

import './index.styles.css'

type AttachmentX = 'left' | 'center' | 'right'
type AttachmentY = 'top' | 'center' | 'bottom'
export type Attachment = Exclude<`${AttachmentY} ${AttachmentX}`, 'center center'>

const attachmentClass: Record<Attachment, string> = {
  'top left': 'DraggableNode_attachment_top_left',
  'top center': 'DraggableNode_attachment_top_center',
  'top right': 'DraggableNode_attachment_top_right',
  'center left': 'DraggableNode_attachment_center_left',
  'center right': 'DraggableNode_attachment_center_right',
  'bottom left': 'DraggableNode_attachment_bottom_left',
  'bottom center': 'DraggableNode_attachment_bottom_center',
  'bottom right': 'DraggableNode_attachment_bottom_right',
}

type Props = {
  coordinates: {
    x: number
    y: number
  }
  attachment?: Attachment
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}

const DraggableNode = ({
  children,
  coordinates,
  attachment = 'top right',
  onMouseEnter,
  onMouseLeave,
}: React.PropsWithChildren<Props>) => {
  const ref = useRef<HTMLDivElement>(null)
  const [attachmentByCoords, setAttachmentByCoords] = useState<Attachment>(attachment)

  useLayoutEffect(() => {
    if (ref.current && coordinates.x - ref.current.clientWidth < 0) {
      setAttachmentByCoords((prev) => prev.replace('right', 'left') as Attachment)
    }
  }, [coordinates.x])

  return document.body
    ? ReactDOM.createPortal(
        <div
          ref={ref}
          className={attachmentClass[attachmentByCoords]}
          style={
            {
              '--draggable-node-x': `${coordinates.x}px`,
              '--draggable-node-y': `${coordinates.y}px`,
            } as React.CSSProperties
          }
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          {children}
        </div>,
        document.body
      )
    : null
}

export default DraggableNode
